import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent } from 'lib-trend-core';

export interface ReportCard {
  title: string;
  icon: string;
  action: () => void;
  hideInProd?: boolean;
}


@Component({
    selector: 'app-report',
    templateUrl: './report.v2.component.html',
    // templateUrl: './report.component.html',
    styleUrls: ['./report.v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportComponent extends AbstractComponent {
  hideInProd = this.env === 'prod';

  public reports: ReportCard[] = [
    {
      title: this.t('report.home.cardAttendance'),
      icon: 'mdi mdi-account-multiple-check',
      action: () => this.viewAttendanceReport(),
    },
    {
      title: this.t('report.home.cardCsat'),
      icon: 'mdi mdi-clipboard-check-outline',
      action: () => this.viewCSATReport(),
    },
    {
      title: this.t('report.home.cardClosingReason'),
      icon: 'mdi mdi-table-large',
      action: () => this.viewReportTabulationAttendance(),
    },
    {
      title: this.t('report.home.cardSalesMonitor'),
      icon: 'mdi mdi-chart-line',
      action: () => this.viewReportSalesMonitorAttendance(),
    },
    {
      title: this.t('report.home.cardImports'),
      icon: 'mdi mdi-database-import-outline',
      action: () => this.viewImportation(),
    },
    {
      title: this.t('report.home.cardAgentPerformance'),
      icon: 'mdi mdi-account-star',
      action: () => this.viewPerformance(),
      hideInProd: this.hideInProd
    },
    {
      title: this.t('report.home.cardNewContactsPerformance'),
      icon: 'mdi mdi-account-plus-outline',
      action: () => this.viewContact(),
      hideInProd: this.hideInProd
    },
    {
      title: this.t('report.home.cardOfficialApiConversations'),
      icon: 'mdi mdi-forum-outline',
      action: () => this.viewInsightsMessages(),
      hideInProd: this.hideInProd
    },
    {
      title: this.t('report.home.cardCloudApiTemplates'),
      icon: 'mdi mdi-xml',
      action: () => this.viewTemplateAnalyticsReport(),
    },
    {
      title: this.t('report.home.cardLeadSource'),
      icon: 'mdi mdi-xml',
      action: () => this.viewLeadSourceReport(),
    },
    {
      title: this.t('report.home.cardApi'),
      icon: 'mdi mdi-xml',
      action: () => this.viewAPIReport(),
    },
  ]
  constructor(injector: Injector) {
    super(injector);
  }

  viewPerformance(): void {
    this.router.navigate(['/report/view-performance'], {
      relativeTo: this.route,
    });
  }

  viewContact(): void {
    this.router.navigate(['/report/view-contact'], {
      relativeTo: this.route,
    });
  }

  viewCloud(): void {
    this.router.navigate(['/report/view'], {
      relativeTo: this.route,
    });
  }

  viewImportation(): void {
    this.router.navigate(['/report/view-importation'], {
      relativeTo: this.route,
    });
  }

  viewCSATReport(): void {
    this.router.navigate(['/report/view-csat'], {
      relativeTo: this.route,
    });
  }

  viewAttendanceReport(): void {
    this.router.navigate(['/report/view-attendance'], {
      relativeTo: this.route,
    });
  }

  viewReportTabulationAttendance(): void {
    this.router.navigate(['/report/view-tabulation-attendance'], {
      relativeTo: this.route,
    });
  }

  viewReportSalesMonitorAttendance(): void {
    this.router.navigate(['/report/view-sales-monitor'], {
      relativeTo: this.route,
    });
  }

  viewTrackingReport(): void {
    this.router.navigate(['/report/view-tracking']);
  }

  viewInsightsMessages(): void {
    this.router.navigate(['/report/view-insights-messages']);
  }

  viewTemplateAnalyticsReport(): void {
    this.router.navigate(['/report/view-insights-templates']);
  }

  viewLeadSourceReport(): void {
    this.router.navigate(['/report/view-lead-source']);
  }

  viewAPIReport(): void {
    this.router.navigate(['/report/view-api-logging'])
  }
}
